/* InputCheckboxEditor.js */

"use strict";

const CommonEditor = require("./CommonEditor");

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const InputCheckboxControl = uiCore.Control.Boolean.InputCheckbox;

class InputCheckboxEditor extends CommonEditor {
    constructor(options) {
        super(options);
        const placeHolderCheckbox = options.item.heading;
        if (placeHolderCheckbox) {
            this.input.placeholder = placeHolderCheckbox;
        }
    }

    _createInput() {
        return new InputCheckboxControl({
            darkTheme: false,
        });
    }

    /*****************************/
    /*  PUBLIC API IS INHERITED  */
    /*****************************/
}

module.exports = InputCheckboxEditor;
